import React from "react";
import { Box, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { mobileNavMediaQuery } from "../../../layout/layoutMetrics";

export default function UserMessage({ msg }) {
  const content = String(msg?.content ?? "").trim();
  const attachmentName = String(msg?.attachmentName ?? "").trim();
  const previewUrl = msg?.attachmentPreviewUrl;
  const attachmentUrl = msg?.attachmentUrl;

  return (
    <Box
      sx={{
        alignSelf: "flex-end",
        maxWidth: "70%",
        [`@media ${mobileNavMediaQuery}`]: {
          maxWidth: "92%",
          minWidth: 0,
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        },
      }}
    >
      <Box
        sx={{
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%)",
          p: 2,
          borderRadius: "18px 18px 2px 18px",
          border: "1px solid rgba(255,255,255,0.1)",
          backdropFilter: "blur(10px)",
          [`@media ${mobileNavMediaQuery}`]: { minWidth: 0 },
        }}
      >
        {previewUrl ? (
          <Box
            component="img"
            src={previewUrl}
            alt={attachmentName || "Attachment"}
            sx={{
              display: "block",
              width: "auto",
              maxWidth: "100%",
              height: "auto",
              maxHeight: { xs: 280, sm: 360 },
              objectFit: "contain",
              objectPosition: "center",
              borderRadius: "12px",
              mb: content ? 1.25 : 0,
            }}
          />
        ) : attachmentName ? (
          <Box
            component={attachmentUrl ? "a" : "div"}
            href={attachmentUrl || undefined}
            target={attachmentUrl ? "_blank" : undefined}
            rel={attachmentUrl ? "noreferrer" : undefined}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              mb: content ? 1 : 0,
              opacity: 0.9,
              color: "inherit",
              textDecoration: "none",
              cursor: attachmentUrl ? "pointer" : "default",
            }}
          >
            <AttachFileIcon sx={{ fontSize: 16 }} />
            <Typography
              variant="body2"
              sx={{
                fontSize: 13,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {attachmentName}
            </Typography>
          </Box>
        ) : null}
        {content ? (
        <Typography
          variant="body2"
          sx={{
            [`@media ${mobileNavMediaQuery}`]: { wordBreak: "break-word" },
          }}
        >
          {content}
        </Typography>
        ) : null}
      </Box>
    </Box>
  );
}